module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国国家银行旧址.9047ffad.png";